import type { Translation } from '../i18n-types';

const fr: Translation = {
  userGuide: 'Guide utilisateur',
  privacyPolicy: 'Politique de confidentialité',
  termsConditions: "Conditions d'utilisation",
  support: 'Support',
  abandoned: 'Abandonné',
  actionComments: "Commentaires d'action",
  actionItem: "Élément d'action",
  actionItemPlaceholder: "Élément d'action...",
  actionItems: "Éléments d'action",
  actionPhaseDescription:
    "Ajoutez des éléments d'action, vous ne pouvez plus regrouper ou voter des commentaires",
  actions: 'Actions',
  activate: 'Activer',
  active: 'Actif',
  activeRetros: 'Rétros actives',
  activeRetroUsers: 'Utilisateurs actifs pour la rétro',
  activeStoryboards: 'Storyboards actifs',
  activeStoryboardUsers: 'Utilisateurs actifs pour le storyboard',
  addComment: 'Ajouter un commentaire',
  addPersona: 'Ajouter une persona',
  admin: 'Admin',
  adminCleanOldRetros: 'Nettoyer les retros de plus de {daysOld} jours',
  adminCleanOldStoryboards:
    'Nettoyer les storyboards de plus de {daysOld} jours',
  adminPageAdmin: 'Administration',
  adminPageAlerts: 'Alertes',
  adminPageApi: 'Clés API',
  adminPageOrganizations: 'Organisations',
  adminPageTeams: 'Équipes',
  adminPageUsers: 'Utilisateurs',
  adminPageSubscriptions: 'Abonnements',
  deleteSubscriptionConfirmation:
    'Êtes-vous sûr de vouloir supprimer cet abonnement ?',
  deleteSubscription: "Supprimer l'abonnement",
  alertAllowDismiss: 'Autoriser la fermeture',
  alertContent: "Contenu de l'alerte",
  alertContentPlaceholder: "Entrez le contenu de l'alerte",
  alertCreate: 'Créer une alerte',
  alertDelete: "Supprimer l'alerte",
  alertDeleteConfirmation: 'Êtes-vous sûr de vouloir supprimer cette alerte ?',
  alertNamePlaceholder: "Entrez un nom d'alerte",
  alertRegisteredOnly: 'Seulement pour les inscrits',
  alerts: 'Alertes',
  alertSave: "Enregistrer l'alerte",
  alertTypePlaceholder: "Sélectionnez un type d'alerte",
  allVotesIn: 'Tous les votes ont été exprimés',
  apiDocumentation: 'Documentation API',
  apikeyCopyFailure: 'Impossible de copier la clé API dans le presse-papiers',
  apikeyCopySuccess: 'Clé API copiée dans le presse-papiers',
  apiKeys: 'Clés API',
  applicationStatsError:
    "Erreur lors de la récupération des statistiques de l'application",
  appName: 'Thunderdome',
  appPreviewAlt: 'Aperçu de Thunderdome, expérience UI de Poker Planning Agile',
  appSubtitle: 'Application Open Source de Poker Planning Agile',
  appVersion: 'version {version}',
  associateTeam: 'Equipe associée',
  authError: "Erreur lors de la tentative d'authentification de l'utilisateur",
  autoFinishVoting: 'Fin automatique du vote',
  avatarAltText: "Emplacement d'avatar",
  back: 'Retour',
  battleAbandon: 'Abandonner le jeu',
  battleCreate: 'Créer un jeu',
  battleDelete: 'Supprimer le jeu',
  battleEdit: 'Modifier le jeu',
  battleEditPointsDisabled:
    'Le vote est actif, impossible de modifier les points autorisés.',
  battleJoin: 'Rejoindre le jeu',
  battleName: 'Nom du jeu',
  battleRemoveError: 'Erreur lors de la tentative de suppression du jeu.',
  battleRemoveSuccess: 'Jeu supprimé avec succès.',
  battles: 'Jeux',
  battlesActive: 'Jeux actifs',
  battlesActiveUsers: 'Utilisateurs actifs pour le jeu',
  becomeFacilitator: 'Devenir facilitateur',
  becomeParticipant: 'Devenir participant',
  becomeSpectator: 'Devenir spectateur',
  blocked: 'Bloqué',
  blockers: 'Blocages',
  blockersPlaceholder: 'Je suis bloqué par...',
  brainstorm: 'Brainstorming',
  brainstormPhaseDescription: 'Ajoutez vos commentaires ci-dessous',
  brainstormPhaseFeedbackVisibility:
    'Visibilité des retours de la phase de brainstorming',
  brainstormVisibilityLabelConcealed: 'Retours dissimulés',
  brainstormVisibilityLabelHidden: 'Retours cachés',
  brainstormVisibilityLabelVisible: 'Retours visibles',
  cancel: 'Annuler',
  cannotBeUndone: 'Cela ne peut pas être annulé.',
  checkIn: 'Enregistrement',
  checkinCommentDeleteError:
    "Erreur lors de la suppression du commentaire sur l'enregistrement",
  checkinCommentError:
    "Erreur lors de l'ajout du commentaire sur l'enregistrement",
  checkinError: "Erreur lors de l'enregistrement",
  checkinMeetYesterdayGoalsQuestion: "Avez-vous atteint les objectifs d'hier ?",
  checkins: 'Enregistrements',
  colorLegend: 'Légende des couleurs',
  colorLegendNotSpecified: 'légende non spécifiée',
  comment: 'Commentaire',
  comments: 'Commentaires',
  completed: 'Terminé',
  conciseVotingResults: 'Résumé des résultats de vote',
  confirmDeleteRetro:
    'Êtes-vous sûr de vouloir supprimer cette rétrospective ?',
  createAccount: 'Créer un compte',
  createAccountTagline: "Vous n'avez pas de compte ?",
  createAlertError: "Erreur lors de la création de l'alerte",
  createAlertSuccess: 'Alerte créée avec succès',
  createARetro: 'Créer une rétro',
  createAStoryboard: 'Créer un storyboard',
  createBattleError: 'Erreur lors de la création du jeu',
  createOrgError: "Erreur lors de la tentative de création de l'organisation",
  createRetro: 'Créer une rétro',
  createRetroErrorMessage: 'Erreur lors de la création de la rétro',
  createStoryboard: 'Créer un storyboard',
  createUserError: "Erreur lors de la création de l'utilisateur",
  customizableBattleOptions: 'Options de jeu personnalisables',
  dateCreated: 'Date de création',
  dateUpdated: 'Date de mise à jour',
  delete: 'Supprimer',
  deleteActionItemError: "Erreur lors de la suppression de l'élément d'action",
  deleteActionItemSuccess: "Élément d'action supprimé avec succès",
  deleteAlertError: "Erreur lors de la tentative de suppression de l'alerte",
  deleteAlertSuccess: 'Alerte supprimée avec succès',
  deleteBattle: 'Supprimer le jeu',
  deleteBattleConfirmText: 'Êtes-vous sûr de vouloir supprimer ce jeu ?',
  deleteBattleError: 'erreur lors de la suppression du jeu',
  deleteCheckinError: "Erreur lors de la suppression de l'enregistrement",
  deleteDepartment: 'Supprimer le département',
  deleteDepartmentConfirmText:
    'Êtes-vous sûr de vouloir supprimer ce département ?',
  deleteOrganization: "Supprimer l'organisation",
  deleteOrganizationConfirmText:
    'Êtes-vous sûr de vouloir supprimer cette organisation ?',
  deleteRetro: 'Supprimer la rétro',
  deleteRetroErrorMessage: 'erreur lors de la suppression de la rétro',
  deleteStoryboard: 'Supprimer le storyboard',
  deleteStoryboardErrorMessage: 'erreur lors de la suppression du storyboard',
  deleteTeam: "Supprimer l'équipe",
  deleteTeamConfirmText: 'Êtes-vous sûr de vouloir supprimer cette équipe ?',
  deleteUserError: "Erreur lors de la suppression de l'utilisateur",
  demote: 'Rétrograder',
  demoteUserError: "Erreur lors de la rétrogradation de l'utilisateur",
  department: 'Département',
  departmentCreate: 'Créer un département',
  departmentCreateError:
    'Erreur lors de la tentative de création du département',
  departmentDeleteError:
    'Erreur lors de la tentative de suppression du département',
  departmentDeleteSuccess: 'Département supprimé avec succès.',
  departmentGetError: 'Erreur lors de la récupération du département',
  departmentName: 'Nom du département',
  departmentNamePlaceholder: 'Entrez un nom de département',
  departments: 'Départements',
  departmentSave: 'Enregistrer le département',
  departmentTeamsGetError:
    'Erreur lors de la récupération des équipes du département',
  departmentUsersGetError:
    'Erreur lors de la récupération des utilisateurs du département',
  discuss: 'Discuter',
  discussPlaceholder: 'Je voudrais discuter...',
  done: 'Terminé',
  duplicateRetroSession: 'Une session de rétro en double existe pour votre ID',
  duplicateStoryboardSession:
    'Une session de storyboard en double existe pour votre ID',
  edit: 'Modifier',
  editColorLegend: 'Modifier la légende',
  editRetro: 'Modifier la rétro',
  editStoryboard: 'Modifier le storyboard',
  email: 'Mail',
  enterPasscode: "Entrez le code d'accès...",
  enterYourEmail: 'Entrez votre mail',
  execute: 'Exécuter',
  export: 'Exporter',
  facilitator: 'Facilitateur',
  facilitatorCode: 'Code facilitateur',
  facilitatorCodeOptional: 'Code facilitateur (optionnel)',
  facilitatorCodePlaceholder: 'Entrez un code facilitateur optionnel',
  finalPoints: 'Points finaux',
  flag: 'Indicateur',
  footerAuthoredBy: 'Créé avec ❤️ par {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'Mot de passe oublié ?',
  forgotPasswordSubtext:
    'Ne vous inquiétez pas ! Entrez simplement votre mail et nous vous enverrons les instructions pour réinitialiser votre mot de passe.',
  returnToLogin: 'Retour sur la page de connexion',
  getAlertsError: 'Erreur lors de la récupération des alertes',
  getApikeysError: 'Erreur lors de la récupération des clés API',
  getBattleError: 'Erreur lors de la récupération du jeu',
  getBattlesError: 'Erreur lors de la récupération des jeux',
  getCheckinsError: 'Erreur lors de la récupération des enregistrements',
  getOrganizationsError: 'Erreur lors de la récupération des organisations',
  getRetroErrorMessage: 'erreur lors de la récupération de la rétro',
  getRetrosErrorMessage: 'erreur lors de la récupération des rétros',
  getStoryboardErrorMessage: 'erreur lors de la récupération du storyboard',
  getStoryboardsErrorMessage: 'erreur lors de la récupération des storyboards',
  getTeamsError: 'Erreur lors de la récupération des équipes',
  getUserError: "Erreur lors de la récupération de l'utilisateur",
  getUsersError: 'Erreur lors de la récupération des utilisateurs',
  goalsMet: 'Objectifs atteints',
  group: 'Groupe',
  groupName: 'Nom du groupe',
  groupPhaseDescription:
    'Faites glisser et déposez les commentaires pour les regrouper',
  hostedDesc:
    '{linkOpen}Thunderdome.dev{linkClose} est un service hébergé gratuit (SaaS) sans publicités.',
  hostedOrSelfHosted: 'Service hébergé ou auto-hébergé',
  importCsv: "Importer des stories à partir d'un fichier CSV",
  importCsvFileBadFileTypeError: 'Erreur de type de fichier incorrect',
  importCsvFileReadFileError: 'Erreur de lecture du fichier',
  importJiraXML: "Importer des stories à partir d'un XML Jira",
  importJiraXMLBadFileTypeError: 'Erreur de type de fichier incorrect',
  importJiraXMLReadFileError: 'Erreur de lecture du fichier',
  incorrectPassCode: "Code d'accès incorrect",
  inviteLinkCopyFailure:
    "Impossible de copier le lien d'invitation dans le presse-papiers",
  inviteLinkCopySuccess: "Lien d'invitation copié dans le presse-papiers",
  jiraXmlImport: 'Import XML Jira',
  joinCodeCopyFailure:
    "Impossible de copier le code d'accès dans le presse-papiers",
  joinCodeCopySuccess: "Code d'accès copié dans le presse-papiers",
  joinCodeLabelOptional: "Code d'accès (optionnel)",
  joinCodePlaceholder: "Entrez un code d'accès",
  joinRetro: 'Rejoindre la rétro',
  joinStoryboard: 'Rejoindre le storyboard',
  joinStoryboardError:
    'Erreur lors de la connexion au storyboard, actualisez et réessayez.',
  landingCountries: 'Utilisateurs dans plus de {count} pays',
  landingFeatureOpenSourceText:
    'Consultez le {repoOpen}dépôt Github{repoClose} pour demander ou contribuer à des améliorations, des traductions et des corrections de bugs ou pour {donateOpen}faire un don{donateClose}.',
  landingFeatureOpenSourceTitle: 'Open Source',
  landingSalesPitch:
    "Collaboration d'équipe à distance avec estimation de stories Agile, rétrospective de sprint, story mapping et enregistrement d'équipe asynchrone.",
  landingTitle: 'Thunderdome est une application de Poker Planning Agile',
  lastActive: 'Dernière activité',
  leaveRetro: 'Quitter la rétro',
  leaveStoryboard: 'Quitter le storyboard',
  legendRetroPlaceholder: 'Entrez une légende de couleur',
  loadingRetro: 'Chargement de la rétro...',
  loadingStoryboard: 'Chargement du storyboard...',
  login: 'Connexion',
  loginForRetro:
    'ou {loginOpen}connectez-vous{loginClose} pour rejoindre la rétro',
  loginForStoryboard:
    'ou {loginOpen}connectez-vous{loginClose} pour rejoindre le storyboard',
  logout: 'Déconnexion',
  logoutError: "Erreur lors de la tentative de déconnexion de l'utilisateur",
  makeFacilitator: 'Nommer un facilitateur',
  mfa2faLabel: 'Authentification 2FA/MFA',
  mfa2faRemove: 'Supprimer FA/MFA',
  mfa2faRemoveFailure: 'Échec de la suppression 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA supprimé avec succès',
  mfa2faRemoveText: 'Êtes-vous sûr de vouloir supprimer 2FA/MFA ?',
  mfa2faSetup: 'Configurer 2FA/MFA',
  mfaAuthError: "Erreur de validation du jeton d'authentification",
  mfaConfirmToken: 'Confirmer le jeton',
  mfaGenerateFailed: "échec de l'initialisation de la configuration 2FA/MFA",
  mfaSecretKeyLabel: 'Clé secrète',
  mfaSetupFailed: 'échec de la validation du jeton de configuration 2FA/MFA',
  mfaSetupIntro:
    "Scannez le code QR suivant avec une application d'authentification (tel que Google Authenticator ou Authy) puis entrez le jeton généré.",
  mfaSetupSuccess: '2FA/MFA activé avec succès',
  mfaTokenLabel: "Jeton d'authentification",
  mfaTokenPlaceholder: "Entrez le jeton de l'application d'authentification",
  myRetros: 'Mes rétros',
  myStoryboards: 'Mes storyboards',
  name: 'Nom',
  needsImprovement: "Besoin d'amélioration",
  nextPhase: 'Phase suivante',
  noComments: 'Pas de commentaires...',
  oldBattleCleanError: 'Erreur lors du nettoyage des jeux',
  oldGuestsCleanError: 'Erreur lors du nettoyage des invités',
  oldRetrosCleanError: 'Erreur lors du nettoyage des rétros',
  oldStoryboardsCleanError: 'Erreur lors du nettoyage des storyboards',
  openSource: 'Open Source',
  optional: '(Optionnel)',
  optionalLeadercodePlaceholder: 'Code leader optionnel pour devenir leader',
  optionalPasscodePlaceholder: "Code d'accès optionnel",
  organization: 'Organisation',
  organizationCreate: 'Créer une organisation',
  organizationDeleteError:
    "Erreur lors de la tentative de suppression de l'organisation",
  organizationDeleteSuccess: 'Organisation supprimée avec succès.',
  organizationGetDepartmentsError:
    "Erreur lors de la récupération des départements de l'organisation",
  organizationGetError: "Erreur lors de la récupération de l'organisation",
  organizationGetTeamsError:
    "Erreur lors de la récupération des équipes de l'organisation",
  organizationGetUsersError:
    "Erreur lors de la récupération des utilisateurs de l'organisation",
  organizationName: "Nom de l'organisation",
  organizationNamePlaceholder: "Entrez un nom d'organisation",
  organizations: 'Organisations',
  organizationsAndTeams: 'Organisations et équipes',
  organizationSave: "Enregistrer l'organisation",
  owner: 'Propriétaire',
  participation: 'Participation',
  passCode: "Code d'accès",
  passCodeRequired: "Code d'accès requis",
  personas: 'Personas',
  planAcceptanceCriteria: "Critères d'acceptation",
  planAcceptanceCriteriaPlaceholder: "Entrez les critères d'acceptation",
  planAdd: 'Ajouter des stories',
  planDescription: 'Description',
  planDescriptionPlaceholder: 'Entrez une description',
  planLink: 'Lien',
  planLinkInvalid:
    "Le lien n'est pas une URL absolue valide, par exemple qui inclut le protocole (HTTP/HTTPS)",
  planLinkPlaceholder: 'Entrez un lien vers la story',
  planName: 'Nom de la story',
  planNamePlaceholder: 'Entrez un nom de story',
  planPriority: 'Priorité',
  planPriorityBlocker: 'Bloquant',
  planPriorityHigh: 'Elevé',
  planPriorityHighest: 'La plus élevée',
  planPriorityLow: 'Faible',
  planPriorityLowest: 'La plus faible',
  planPriorityMedium: 'Moyen',
  planPriorityPlaceholder: 'Sélectionnez une priorité',
  planReferenceId: 'ID de référence',
  planReferenceIdPlaceholder: 'Entrez un ID de référence',
  plans: 'Stories',
  planSkip: 'Passer la story',
  planType: 'Type de story',
  planTypeBug: 'Bug',
  planTypeEpic: 'Épopée',
  planTypePlaceholder: 'Types',
  planTypeSpike: 'Spike',
  planTypeStory: 'Story',
  planTypeSubtask: 'Sous-tâche',
  planTypeTask: 'Tâche',
  pointAverageRounding: 'Moyenne des points arrondie',
  pointed: 'Estimé ({count})',
  points: 'Points',
  pointValuesAllowed: 'Valeurs de points autorisées',
  postComment: 'Poster un commentaire',
  primeDirective: 'Directive principale',
  promote: 'Promouvoir',
  promoteUserError: "Erreur lors de la promotion de l'utilisateur",
  questions: 'Questions',
  register: "s'inscrire",
  reloadingRetro: 'Oups, rechargement de la rétro...',
  reloadingStoryboard: 'Oups, rechargement du storyboard...',
  remove: 'Supprimer',
  removeBattle: 'Supprimer le jeu',
  removeBattleConfirmText: 'Êtes-vous sûr de vouloir supprimer ce jeu ?',
  removeRetro: 'Supprimer la rétro',
  removeRetroConfirmText: 'Êtes-vous sûr de vouloir supprimer cette rétro ?',
  removeStoryboard: 'Supprimer le storyboard',
  removeStoryboardConfirmText:
    'Êtes-vous sûr de vouloir supprimer ce storyboard ?',
  removeUser: "Supprimer l'utilisateur",
  removeUserConfirmText: 'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
  requestVerifyEmail: "Demander l'envoi d'un mail de vérification",
  requestVerifyEmailFailure: "Erreur lors de l'envoi du mail de vérification",
  requestVerifyEmailSuccess:
    'Mail de vérification envoyé, vérifiez votre boîte de réception',
  retro: 'Rétro',
  retroActionCommentAddError:
    "Erreur lors de l'ajout du commentaire sur l'action de rétro",
  retroActionCommentDeleteError:
    "Erreur lors de la suppression du commentaire sur l'action de rétro",
  retroActionCommentEditError:
    "Erreur lors de la modification du commentaire sur l'action de rétro",
  retroActionItems: "Éléments d'action de rétro",
  retroAddError: "Erreur lors de l'ajout de la rétro.",
  retroAddSuccess: 'Rétro ajoutée avec succès.',
  retroDeleted: 'Rétro supprimée',
  retroFeedbackConcealed: 'Retour dissimulé',
  retroFeedbackHidden: 'Retour caché',
  retroImprovePlaceholder: 'Ce qui doit être amélioré...',
  retroItems: 'Éléments de rétro',
  retroJoinError:
    'Erreur lors de la connexion à la rétro, actualisez et réessayez.',
  retroMaxVotesPerUserLabel: 'Votes max par groupe (par utilisateur)',
  retroName: 'Nom de la rétro',
  retroNamePlaceholder: 'Entrez un nom de rétro',
  retroQuestionPlaceholder: 'Je veux poser une question...',
  retroRemoveError: 'Erreur lors de la suppression de la rétro.',
  retroRemoveSuccess: 'Rétro supprimée avec succès.',
  retros: 'Rétros',
  retroWorkedPlaceholder: 'Ce qui a bien fonctionné...',
  role: 'Rôle',
  rolePlaceholder: 'Sélectionnez un rôle utilisateur',
  save: 'Enregistrer',
  search: 'Rechercher',
  searchLengthError:
    'La valeur de recherche doit comporter au moins 3 caractères',
  selectTeam: 'Sélectionnez une équipe',
  selfHostedDesc:
    "Alternativement, vous pouvez {linkOpen}l'exécuter sur votre propre serveur{linkClose}.",
  sessionDuplicate: 'Une session de jeu en double existe pour votre ID',
  showActiveBattles: 'Afficher les jeux actifs',
  showActiveRetros: 'Afficher les rétros actives',
  showActiveStoryboards: 'Afficher les storyboards actifs',
  showBlockedCheckins:
    'Afficher uniquement les enregistrements nécessitant une discussion',
  showCompletedActionItems: "Afficher les éléments d'action terminés",
  showVoters: 'Afficher les votants',
  skipped: 'Passé',
  spectator: 'Spectateur',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Ajouter une colonne',
  storyboardAddError: "Erreur lors de l'ajout du storyboard.",
  storyboardAddGoal: 'Ajouter un objectif',
  storyboardAddStoryToColumn: 'Ajouter une story à la colonne',
  storyboardAddSuccess: 'Storyboard ajouté avec succès.',
  storyboardColumns: 'Colonnes du storyboard',
  storyboardDeleted: 'Storyboard supprimé',
  storyboardEditColumn: 'Modifier la colonne',
  storyboardGoalName: "Nom de l'objectif",
  storyboardGoalNamePlaceholder: "Entrez un nom d'objectif",
  storyboardGoals: 'Objectifs du storyboard',
  storyboardPersonas: 'Personas du storyboard',
  storyboardRemoveError: 'Erreur lors de la suppression du storyboard.',
  storyboardRemoveSuccess: 'Storyboard supprimé avec succès.',
  storyboards: 'Storyboards',
  storyboardStories: 'Stories du storyboard',
  team: 'Équipe',
  teamCheckins: "Enregistrements de l'équipe",
  teamCreate: 'Créer une équipe',
  teamCreateError: "Erreur lors de la création de l'équipe.",
  teamCreateSuccess: 'Équipe créée avec succès.',
  teamDeleteError: "Erreur lors de la suppression de l'équipe",
  teamDeleteSuccess: 'Équipe supprimée avec succès.',
  teamGetBattlesError: "Erreur lors de la récupération des jeux de l'équipe",
  teamGetError: "Erreur lors de la récupération de l'équipe",
  teamGetRetroActionsError:
    "Erreur lors de la récupération des actions de rétro de l'équipe",
  teamGetRetrosError: "Erreur lors de la récupération des rétros de l'équipe",
  teamGetStoryboardsError:
    "Erreur lors de la récupération des storyboards de l'équipe",
  teamGetUsersError:
    "Erreur lors de la récupération des utilisateurs de l'équipe",
  teamName: "Nom de l'équipe",
  teamNamePlaceholder: "Entrez un nom d'équipe",
  teams: 'Équipes',
  teamSave: "Enregistrer l'équipe",
  teamUserRequiredToCheckin:
    "L'utilisateur doit être dans l'équipe pour s'enregistrer",
  teamUserRequiredToComment:
    "L'utilisateur doit être dans l'équipe pour commenter",
  today: "Aujourd'hui",
  todayPlaceholder: "Aujourd'hui, je vais...",
  totalPoints: 'Total',
  totalVotes: 'Total des votes',
  type: 'Type',
  unknownWarrior: 'Joueur inconnu',
  unpointed: 'Non-estimé ({count})',
  updateActionItemError: "Erreur lors de la mise à jour de l'élément d'action",
  updateActionItemSuccess: "Élément d'action mis à jour avec succès",
  updateAlertError: "Erreur lors de la mise à jour de l'alerte",
  updateAlertSuccess: 'Alerte mise à jour avec succès',
  updateCheckinError: "Erreur lors de la mise à jour de l'enregistrement",
  updateComment: 'Mettre à jour le commentaire',
  userAdd: 'Ajouter un utilisateur',
  userAddError: "Erreur lors de l'ajout de l'utilisateur.",
  userAddSuccess: 'Utilisateur ajouté avec succès.',
  userEmail: "Mail de l'utilisateur",
  userEmailPlaceholder: "Entrez le mail de l'utilisateur",
  userName: "Nom de l'utilisateur",
  userRemoveError: "Erreur lors de la suppression de l'utilisateur.",
  userRemoveSuccess: 'Utilisateur supprimé avec succès.',
  users: 'Utilisateurs',
  verifyAccount: 'Vérifier le compte',
  verifyAccountFailedError:
    "Quelque chose s'est mal passé lors de la vérification de votre compte, peut-être que ce lien a expiré ou a déjà été utilisé.",
  verifyAccountFailedTitle: 'Échec de la vérification',
  verifyAccountLoading: 'Vérification du compte...',
  verifyAccountVerifiedThanks: "Merci d'avoir vérifié votre mail.",
  verifyAccountVerifiedTitle: 'Compte vérifié',
  view: 'Voir',
  vote: 'Voter',
  voteCount: 'Nombre de votes',
  votePhaseDescription:
    'Votez pour les groupes dont vous souhaiteriez discuter plus en détail',
  voteResultsAverage: 'Moyenne',
  voteResultsHighest: 'Le plus élevé',
  votingFinish: 'Terminer le vote',
  votingLocked: 'Vote verrouillé',
  votingRestart: 'Redémarrer le vote',
  warriorCreate: 'Créer un utilisateur',
  warriorInvite: 'Inviter un joueur',
  warriorNudge: 'Secouer',
  works: 'Travaux',
  writeCommentPlaceholder: 'Écrire un commentaire...',
  yesterday: 'Hier',
  yesterdayPlaceholder: "Hier, j'ai...",
  yourRetros: 'Vos rétros',
  yourStoryboards: 'Vos storyboards',
  addPlan: 'Ajouter une story',
  battleNamePlaceholder: 'Entrez un nom de jeu',
  autoFinishVotingLabel:
    'Terminer automatiquement le vote lorsque tous les joueurs ont voté',
  averageRoundingOptions: {
    ceil: 'Par excès',
    floor: 'Par troncature',
    round: 'Par arrondi',
  },
  apiKeyCreateButton: 'Créer une clé API',
  apiKeyPrefix: 'Préfixe de la clé',
  lastUpdated: 'Dernière mise à jour',
  apiKeysErrorRetrieving: 'Échec de la récupération des clés API',
  apiKeyDeleteSuccess: 'Clé API supprimée',
  apiKeyDeleteFailed: 'Échec de la suppression de la clé API',
  apiKeyUpdateSuccess: 'Clé API mise à jour',
  apiKeyUpdateFailed: 'Échec de la mise à jour de la clé API',
  deactivate: 'Désactiver',
  profileErrorRetrieving: 'Erreur lors de la récupération de votre profil',
  profileErrorUpdating: 'Erreur lors de la mise à jour de votre profil',
  profileUpdateSuccess: 'Profil mis à jour',
  passwordUpdated: 'Mot de passe mis à jour.',
  passwordUpdateError:
    'Erreur lors de la tentative de mise à jour du mot de passe',
  profileDeleteError:
    'Erreur lors de la tentative de suppression de votre compte.',
  profileTitle: 'Votre profil',
  profile: 'Profil',
  updatePassword: 'Mettre à jour le mot de passe',
  deleteAccount: 'Supprimer le compte',
  deleteAccountWarningStatement:
    'Êtes-vous sûr de vouloir supprimer votre compte ?',
  deleteConfirmButton: 'Confirmer la suppression',
  apiKeyNameInvalid: 'Veuillez entrer un nom de clé',
  apiKeyCreateSuccess:
    'Nouvelle clé API {keyName} créée, {onlyNowOpen}elle sera affichée uniquement maintenant{onlyNowClose}',
  apiKeyStoreWarning:
    'Veuillez la stocker en lieu sûr car dès lors que vous quitterez cette page, nous ne pourrons plus récupérer ou restaurer cette clé générée.',
  apiKeyLimitReached:
    'Vous avez atteint le nombre maximum de clés API autorisées.',
  apiKeyUnverifiedUser:
    'Seuls les utilisateurs inscrits et vérifiés peuvent créer des clés API.',
  apiKeyCreateFailed: 'Échec de la création de la clé API',
  apiKeyName: 'Nom de la clé',
  apiKeyNamePlaceholder: 'Entrez un nom pour la clé',
  create: 'Créer',
  close: 'Fermer',
  country: 'Pays',
  company: 'Entreprise',
  verified: 'Vérifié',
  registeredUsers: 'Utilisateurs inscrits',
  myBattles: 'Mes jeux',
  createBattle: 'Créer un jeu',
  countPlansPointed: '{totalPointed} sur {totalPlans} stories estimées',
  myBattlesError: 'Erreur lors de la recherche de vos jeux',
  warriorJoined: '{name} a rejoint le jeu',
  warriorRetreated: '{name} a quitté le jeu',
  planSkipped: 'Story passée',
  warriorVoted: '{name} a voté',
  warriorRetractedVote: '{name} a retiré son vote',
  battleDeleted: 'Jeu supprimé',
  warriorNudgeMessage: 'pst... {name}, nous attendons votre vote.',
  battle: 'Jeu',
  warriors: 'Joueurs',
  battleSocketReconnecting: 'Oups, rechargement du jeu...',
  battleSocketError:
    'Erreur lors de la connexion au jeu, actualisez et réessayez.',
  battleLoading: 'Chargement du jeu...',
  votingNotStarted: "Le vote n'a pas commencé",
  password: 'Mot de passe',
  passwordPlaceholder: 'Entrez un mot de passe',
  yourPasswordPlaceholder: 'Entrez votre mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
  update: 'Mettre à jour',
  reset: 'Réinitialiser',
  passwordResetError:
    'Erreur lors de la tentative de réinitialisation du mot de passe',
  resetPassword: 'Réinitialiser le mot de passe',
  registerAsGuest: "S'inscrire en tant qu'invité",
  registrationDisabled: "L'inscription est désactivée.",
  userNamePlaceholder: 'Entrez votre nom',
  guestRegisterError:
    "Erreur lors de la tentative d'inscription en tant qu'invité",
  registerError: "Erreur lors de la tentative d'inscription",
  enlistToBattle: "S'inscrire au jeu",
  loginForBattle:
    'ou {loginOpen}connectez-vous{loginClose} pour rejoindre le jeu',
  yourNamePlaceholder: 'Entrez votre nom',
  createAccountFormTitle:
    'Créer un compte {optionalOpen}(optionnel){optionalClose}',
  sendResetPasswordSuccess:
    'Instructions de réinitialisation du mot de passe envoyées à {email}',
  sendResetPasswordError:
    "Erreur lors de la tentative d'envoi de la réinitialisation du mot de passe",
  chooseCountryPlaceholder: 'Choisissez votre pays (optionnel)',
  locale: 'Langue',
  companyPlaceholder: "Entrez votre nom d'entreprise (optionnel)",
  jobTitle: 'Titre du poste',
  jobTitlePlaceholder: 'Entrez votre titre de poste (optionnel)',
  enableBattleNotifications: 'Activer les notifications de jeu',
  avatar: 'Avatar',
  updateProfile: 'Mettre à jour le profil',
  guestUsers: 'Utilisateurs invités',
  maintenance: 'Maintenance',
  cleanGuests: 'Nettoyer les invités de plus de {daysOld} jours',
  cleanBattles: 'Nettoyer les jeux de plus de {daysOld} jours',
  chooseLocalePlaceholder: 'Choisissez votre langue préférée (optionnel)',
  importPlans: 'Importer des stories',
  selectFile: 'Sélectionner un fichier...',
  theme: 'Thème',
  assignees: 'Responsables',
  assigneeSelectPlaceholder: 'Sélectionnez un responsable à ajouter',
  assigneeAdd: 'Ajouter un responsable',
  allStoryWithCount: 'Toutes ({count})',
  userUpdate: "Mettre à jour l'utilisateur",
  userUpdateSuccess: 'Utilisateur mis à jour avec succès.',
  userUpdateError: "Erreur lors de la mise à jour de l'utilisateur.",
  userInvites: "Invitations d'utilisateur",
  userInviteSent: "Invitation d'utilisateur envoyée",
  userInviteConfirmDelete:
    "Êtes-vous sûr de vouloir supprimer cette invitation d'utilisateur ?",
  userInviteDelete: "Supprimer l'invitation",
  expireDate: "Date d'expiration",
  addUserWillInviteNotFoundFieldNote:
    "Si l'utilisateur n'est pas inscrit, une invitation à s'inscrire et à rejoindre le {pageType} sera envoyée.",
  inviteUserFieldNote: 'Une invitation à rejoindre le {pageType} sera envoyée.',
  requiresOrganizationMember:
    "L'utilisateur doit déjà être dans l'organisation.",
  teamUpdateSuccess: 'Équipe mise à jour avec succès',
  teamUpdateError: "Erreur lors de la mise à jour de l'équipe",
  orgUpdateSuccess: 'Organisation mise à jour avec succès',
  orgUpdateError: "Erreur lors de la mise à jour de l'organisation",
  deptUpdateSuccess: 'Département mis à jour avec succès',
  deptUpdateError: 'Erreur lors de la mise à jour du département',
  hideVoterIdentity: "Masquer l'identité du votant",
  storyboardName: 'Nom du storyboard',
  storyboardNamePlaceholder: 'Entrez un nom de storyboard',
  retroPhaseTimeLimitMinLabel:
    'Limite de temps de la phase de brainstorming en minutes',
  phaseAutoAdvanceLabel: 'Dérouler automatiquement les phases',
  removeOnlyFacilitatorError: "Impossible de supprimer l'unique facilitateur",
  noGamesFound: "Aucun jeu trouvé, essayez d'en créer un.",
  noRetrosFound: "Aucune rétro trouvée, essayez d'en créer une.",
  noStoryboardsFound: "Aucun storyboard trouvé, essayez d'en créer un.",
  retroDescription:
    'Une rétrospective de sprint est une revue effectuée après un sprint qui joue un rôle clé dans la méthodologie Agile. Une rétrospective de sprint vise à déterminer ce qui a bien fonctionné et où vous avez rencontré des problèmes, et à identifier les domaines où vous pouvez vous améliorer.',
  pokerDescription:
    "Le poker planning est une façon ludique que les équipes de développement utilisent pour estimer l'effort des tâches de gestion de projet. Ces estimations sont basées sur les contributions et le consensus de l'ensemble du groupe, les rendant plus engageantes et précises que d'autres méthodes.",
  storyboardDescription:
    "Le user story mapping (storyboard) est une méthode de visualisation du parcours utilisateur effectué avec un produit, du début à la fin. Elle inclut toutes les tâches qu'ils accompliraient typiquement dans le cadre de ce parcours.",
  estimationScaleNamePlaceholder: "Entrez le nom de l'échelle",
  description: 'Description',
  estimationScaleDescriptionPlaceholder: "Entrez la description de l'échelle",
  scaleType: "Type d'échelle",
  estimationScaleTypePlaceholder: "Sélectionnez le type d'échelle",
  scaleValues: "Valeurs de l'échelle",
  estimationScaleValuesPlaceholder:
    'Entrez des valeurs séparées par des virgules',
  estimationScaleValuesHelp:
    'Entrez des valeurs séparées par des virgules (par exemple, 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Rendre cette échelle publique',
  estimationScaleDefault: 'Définir comme échelle par défaut',
  estimationScaleSave: "Enregistrer l'échelle",
  estimationScales: "Échelles d'estimation",
  estimationScaleCreate: "Créer une échelle d'estimation",
  estimationScaleCreateSuccess: "Échelle d'estimation créée avec succès",
  estimationScaleCreateError:
    "Erreur lors de la création de l'échelle d'estimation",
  estimationScaleUpdateSuccess: "Échelle d'estimation mise à jour avec succès",
  estimationScaleUpdateError:
    "Erreur lors de la mise à jour de l'échelle d'estimation",
  estimationScaleRemoveSuccess: "Échelle d'estimation supprimée avec succès",
  estimationScaleRemoveError:
    "Erreur lors de la suppression de l'échelle d'estimation",
  removeEstimationScaleConfirmText:
    "Êtes-vous sûr de vouloir supprimer cette échelle d'estimation ?",
  removeEstimationScale: "Supprimer l'échelle d'estimation",
  yes: 'Oui',
  no: 'Non',
  isPublic: 'Public',
  default: 'Par défaut',
  publicEstimationScales: "Échelles d'estimation publiques",
  organizationEstimationScales: "Échelles d'estimation de l'organisation",
  teamEstimationScales: "Échelles d'estimation de l'équipe",
  allowCumulativeVotingLabel:
    "Autoriser le vote cumulatif (plus d'un vote par groupe d'éléments)",
  activeSubscriptions: 'Abonnements actifs',
  retroTemplates: 'Modèles de rétrospective',
  publicRetroTemplates: 'Modèles de rétrospective publics',
  organizationRetroTemplates: "Modèles de rétrospective de l'organisation",
  teamRetroTemplates: "Modèles de rétrospective de l'équipe",
  retroTemplateNamePlaceholder: 'Entrez le nom du modèle',
  retroTemplateDescriptionPlaceholder: 'Entrez la description du modèle',
  format: 'Format',
  retroTemplateIsPublic: 'Rendre ce modèle public',
  retroTemplateSave: 'Enregistrer le modèle',
  retroTemplateCreate: 'Créer un modèle de rétrospective',
  retroTemplateCreateSuccess: 'Modèle de rétrospective créé avec succès',
  retroTemplateCreateError:
    'Erreur lors de la création du modèle de rétrospective',
  retroTemplateUpdateSuccess: 'Modèle de rétrospective mis à jour avec succès',
  retroTemplateUpdateError:
    'Erreur lors de la mise à jour du modèle de rétrospective',
  retroTemplateRemoveSuccess: 'Modèle de rétrospective supprimé avec succès',
  retroTemplateRemoveError:
    'Erreur lors de la suppression du modèle de rétrospective',
  removeRetroTemplateConfirmText:
    'Êtes-vous sûr de vouloir supprimer ce modèle de rétrospective ?',
  removeRetroTemplate: 'Supprimer le modèle de rétrospective',
  retroTemplateDefault: 'Définir comme modèle par défaut',
  jiradatacenterLabel: 'Jira DataCenter',
  loginWithSSO: 'Se connecter avec {provider}',
  requestEmailChangeSuccess:
    'Demande de changement de mail envoyée, vérifiez votre boîte de réception pour les instructions',
  requestEmailChangeError: 'Erreur lors de la tentative de changement de mail',
  changeEmail: 'Changer le mail',
  errorChangingEmail:
    'Erreur lors de la tentative de changement de mail, peut-être que ce lien a expiré ou a déjà été utilisé.',
  emailChanged: 'Mail changé avec succès',
  newEmailToLogin:
    'À partir de maintenant, utilisez votre nouveau mail pour vous connecter.',
  newEmail: 'Nouveau mail',
  enterYourNewEmail: 'Entrez votre nouveau mail',
  retroSettings: 'Paramètres de rétro',
  enterFacilitatorCode: 'Entrez le code facilitateur',
  // Modal ariaLabels
  modalCreateAlert: 'Créer une alerte',
  modalUpdateEstimationScale: "Mettre à jour l'échelle d'estimation",
  modalDeleteConfirmation: 'Confirmation de suppression',
  modalCreateEstimationScale: "Créer une échelle d'estimation",
  modalTeamCheckin: "Point d'équipe",
  modalAddPokerStory: 'Ajouter une histoire de poker',
  modalCreateUser: 'Créer un utilisateur',
  modalCreateApiKey: 'Créer une clé API',
  modalImportPokerStories: 'Importer des histoires de poker',
  modalSetupMultifactorAuth: "Configurer l'authentification multifactorielle",
  modalEditPokerGame: 'Modifier le jeu de poker',
  modalCreateJiraInstance: 'Créer une instance Jira',
  modalUpdatePokerSettings: 'Mettre à jour les paramètres de poker',
  modalAddStoryboardGoal: 'Ajouter un objectif de storyboard',
  modalViewPokerStory: "Voir l'histoire de poker",
  modalStoryboardColumnSettings: 'Paramètres de colonne de storyboard',
  modalEditStoryboard: 'Modifier le storyboard',
  modalStoryboardColorLegend: 'Légende de couleur de storyboard',
  modalStoryboardPersonas: 'Personas de storyboard',
  modalRetroActionComments: "Commentaires d'action de rétro",
  modalStoryboardStory: 'Histoire de storyboard',
  modalTeamAddUser: "Ajouter un utilisateur à l'équipe",
  modalCreateDepartment: 'Créer un département',
  modalCreateTeam: 'Créer une équipe',
  modalCreateOrganization: 'Créer une organisation',
  modalCreateRetroTemplate: 'Créer un modèle de rétrospective',
  modalViewRetroTemplateFormat: 'Voir le format du modèle de rétrospective',
  modalUpdateRetroTemplate: 'Mettre à jour le modèle de rétrospective',
  modalAssociateTeamToSubscription: "Associer l'équipe à l'abonnement",
  modalAssociateOrganizationToSubscription:
    "Associer l'organisation à l'abonnement",
  modalTeamUpdateUser: "Mettre à jour l'utilisateur de l'équipe",
  modalSubscriptionForm: "Formulaire d'abonnement",
  modalEditRetro: 'Modifier la rétrospective',
  modalEditRetroActionItem: "Modifier l'élément d'action de rétro",
  modalRetroItemComments: "Commentaires d'élément de rétro",
  modalUpdateRetroSettings: 'Mettre à jour les paramètres de rétro',
  githubRepository: 'Dépôt GitHub',
  projects: 'Projets',
  projectCreate: 'Créer un projet',
  projectKey: 'Clé de projet',
  scope: 'Portée',
  createdAt: 'Créé le',
  projectRemoveSuccess: 'Projet supprimé avec succès',
  projectRemoveError: 'Échec de la suppression du projet',
  removeProjectConfirmText:
    'Êtes-vous sûr de vouloir supprimer ce projet ? Cette action ne peut pas être annulée.',
  removeProject: 'Supprimer le projet',
  modalCreateProject: 'Créer un Projet',
  modalUpdateProject: 'Mettre à Jour le Projet',
  projectKeyPlaceholder: 'Saisissez la clé du projet (ex. PROJ)',
  projectNamePlaceholder: 'Saisissez le nom du projet',
  projectDescriptionPlaceholder:
    'Saisissez la description du projet (facultatif)',
  projectKeyValidationError:
    'La clé du projet doit contenir 2-10 caractères alphanumériques',
  projectKeyHelp: '2-10 caractères, lettres et chiffres uniquement',
  projectScope: 'Portée du Projet',
  projectUpdate: 'Mettre à Jour le Projet',
  projectCreateSuccess: 'Projet créé avec succès',
  projectUpdateSuccess: 'Projet mis à jour avec succès',
  projectCreateError: 'Échec de la création du projet',
  projectUpdateError: 'Échec de la mise à jour du projet',
};

export default fr;
